import { fetcherPaginated, fetcherPost, fetcherDelete, fetcherGet, fetcherPatch } from './fetcher'
import { omit, indexBy, prop, map, forEach } from 'ramda'

const promises = {}

export default class EntityPresenter {
  static urn = ''
  static version = 'v1'

  static async get(urn, query = {}, options = {}) {
    const { force = false, filter = null, ...restOptions } = options
    const key = urn + JSON.stringify(query) + JSON.stringify(restOptions) + JSON.stringify(filter)

    const cached = promises[key]
    const isValid = cached && cached.t > Date.now()

    const p = !force && isValid ? cached.p : null
    let url = `${ this.version }/${ this.urn }/${ urn }`

    if (filter) {
      url = `${ this.version }/${ this.urn }?${ filter }`
    }

    if (!p) {
      const request = fetcherGet(url, {
        query,
        ...restOptions,
      })

      promises[key] = {
        p: request,
        t: Date.now() + 10 * 1000,
      }
    }

    return promises[key].p
  }

  static async post(urn, body, options, appendHeaders) {
    return fetcherPost(`${ this.version }/${ this.urn }/${ urn }`, body, options, appendHeaders)
  }

  static async patch(urn, body, options = {}) {
    return fetcherPatch(`${ this.version }/${ this.urn }/${ urn }`, body, options)
  }

  static async delete(urn) {
    return fetcherDelete(`${ this.version }/${ this.urn }/${ urn }`)
  }

  static async paginated(query = {}, options = {}) {
    return fetcherPaginated(`${ this.version }/${ this.urn }`, {
      query,
      ...options,
    })
  }

  static async read(query = {}, options = {}) {
    return fetcherGet(`${ this.version }/${ this.urn }`, {
      query,
      ...options,
    })
  }

  static async readIndexed(cacheRef, key = 'id') {
    const items = await this.read()

    if (!cacheRef.current) {
      cacheRef.current = {}
    }

    cacheRef.current.items = items
    cacheRef.current.ids = map(prop(key), items)
    cacheRef.current.indexed = indexBy(prop(key), items)

    return cacheRef.current.ids
  }

  static async findOne(id) {
    return await fetcherGet(`${ this.version }/${ this.urn }/${ id }`)
  }

  static async upsert(body) {
    return await fetcherPost(`${ this.version }/${ this.urn }`, body)
  }

  static async path(body) {
    return await fetcherPost(`${ this.version }/${ this.urn }/${ body.id }`, omit(['id'], body))
  }

  static async remove(body) {
    return this.delete(body.id)
  }

  /**
   * @return {{
   *   icon: string
   *  }}
   */
  static navOptions() {
    throw new Error('NavOptions not implemented')
  }
}

export function bindPresenterMethods(presenter) {
  forEach(
    (method) => presenter[method] = presenter[method].bind(presenter),
    [
      'get', 'post', 'patch', 'delete', 'paginated', 'read', 'readIndexed',
      'findOne', 'upsert', 'path', 'remove',
    ],
  )
}
